(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[459],{

/***/ 3236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(4202);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/auth/login.module.css
var login_module = __webpack_require__(2911);
var login_module_default = /*#__PURE__*/__webpack_require__.n(login_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(3299);
;// CONCATENATED MODULE: ./components/auth/login.tsx






function Login() {
    const router = (0,next_router.useRouter)();
    const emailInputRef = (0,react.useRef)(null);
    const passwordInputRef = (0,react.useRef)(null);
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    async function submitHandler(event) {
        event.preventDefault();
        const enteredEmail = emailInputRef.current.value;
        const enteredPassword = passwordInputRef.current.value;
        const result = await (0,next_auth_react.signIn)("credentials", {
            redirect: false,
            email: enteredEmail,
            password: enteredPassword
        });
        if (!result.error) {
            router.replace("/profile");
        } else {
            setErrorMessage(result.error);
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (login_module_default()).profile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (login_module_default()).itemleft,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "h1",
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "material-icons",
                            children: "account_circle"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "form",
                onSubmit: submitHandler,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "login-input-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            autoComplete: "off",
                            className: "login-input",
                            type: "email",
                            id: "email",
                            ref: emailInputRef,
                            placeholder: "Email Address"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "login-input-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            autoComplete: "off",
                            className: "login-input",
                            type: "password",
                            id: "password",
                            ref: passwordInputRef,
                            placeholder: "Password"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "error",
                        className: (login_module_default()).errorMessage,
                        children: [
                            errorMessage,
                            errorMessage !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "material-icons",
                                style: {
                                    marginLeft: "0.5rem"
                                },
                                children: "error"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/signup",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor align-center no-select underline",
                            children: "Create Account"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "buttons no-select",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "button",
                            children: "Login"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var login = (Login);

;// CONCATENATED MODULE: ./pages/login.tsx


function LoginPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(login, {});
}
var __N_SSP = true;
/* harmony default export */ var pages_login = (LoginPage);


/***/ }),

/***/ 2911:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"login_errorMessage__XW28l","profile":"login_profile__3HA7V","itemleft":"login_itemleft__GuAm3","itemright":"login_itemright__93SGW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);